import Helper from '@ember/component/helper'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'

interface Signature {
  Return: boolean
}

/**
 * When a school uses an external rostering service, TUI needs to show or hide certain features.
 */
export class usesExternalRostering extends Helper<Signature> {
  @service session!: SessionService

  compute() {
    return this.session.currentSchool.usesExternalRostering
  }
}

export default usesExternalRostering
